/**
 * This is an empty component that is used while lazy loaded modals are loading.
 */
const Loading = () => <div></div>;

export default Loading;